(function () {
  'use strict';

  /* Shopify can evaluate a section's deferred script again when the theme
     editor reloads that section. Keep one set of document listeners alive. */
  if (window.__deCartInitialized) return;

  /*
   * ==========================================================
   * SID'S FARM - DAILY ESSENTIALS
   * FAST CART DRAWER
   * ==========================================================
   */

  const drawer = document.getElementById('de-cart-drawer');

  if (!drawer) return;

  window.__deCartInitialized = true;

  document.body.appendChild(drawer);

  const itemsContainer =
    document.getElementById('de-cart-items');

  const subtotalElement =
    document.getElementById('de-cart-subtotal');

  const itemCountElement =
    document.getElementById('de-cart-item-count');

  const deliveryMessage =
    document.getElementById('de-cart-delivery-message');

  const closeButton =
    drawer.querySelector('.de-cart-drawer__close');

  const overlay =
    drawer.querySelector('.de-cart-drawer__overlay');

  const promoPanel = drawer.querySelector('.de-cart-promo');
  const promoLabel = document.getElementById('de-cart-promo-label');
  const promoRemove = document.getElementById('de-cart-promo-remove');
  const checkoutLink = drawer.querySelector('.de-cart-drawer__checkout');
  const promoForm = drawer.querySelector('.de-cart-promo__form');
  const promoInput = promoForm && promoForm.querySelector('input');
  const promoSubmit = promoForm && promoForm.querySelector('button[type="submit"]');
  const promoFeedback = drawer.querySelector('[data-de-promo-feedback]');
  let promoBusy = false;
  /* Last cart Shopify returned (set on every render). Lets the drawer's
     quantity buttons act without first re-fetching /cart.js. */
  let lastCart = null;
  let cartRequestPromise = null;
  let cartMutationQueue = Promise.resolve();

  /* Keep cart writes in order so a slower response from an older click
     cannot overwrite a newer cart state or discount calculation. */
  function serializeCartMutation(operation) {
    const result = cartMutationQueue.then(operation, operation);
    cartMutationQueue = result.then(function () {}, function () {});
    return result;
  }

  /*
   * Promo code lifetime. Shopify keeps a discount code on the cart for as
   * long as the cart lives, so the theme decides when to drop it: the code
   * survives refreshes, navigation and adding items, but is removed when a
   * new browser session starts or when the signed-in customer signs out
   * (including via Shopify's own account pages, which never run
   * dePrepareCustomerLogout). A guest who signs in keeps the code.
   * de_promo_session is a session cookie (no expiry, shared by all tabs)
   * holding who was browsing on the previous page: a customer id or "guest".
   * Exception: a code that arrived through a Shopify discount link
   * (/discount/CODE) is kept even at the start of a session. Shopify stores
   * it on the cart right away (it applies once products are added) and
   * records it in its own session cookie, discount_code.
   */
  const PROMO_SESSION_COOKIE = 'de_promo_session';
  const currentShopper = drawer.dataset.customerId || 'guest';

  function readCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  const previousShopper = readCookie(PROMO_SESSION_COOKIE);
  const promoSessionEnded = !previousShopper || (previousShopper !== 'guest' && previousShopper !== currentShopper);
  document.cookie = PROMO_SESSION_COOKIE + '=' + encodeURIComponent(currentShopper) + '; path=/; SameSite=Lax';
  let promoSessionChecked = false;

  /* True when the cart carries a code that should not survive into this
     session, i.e. any code other than one from a discount link. */
  function cartHasStalePromo(cart) {
    const linkCode = readCookie('discount_code').trim().toUpperCase();
    const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    return codes.length > 0 && !codes.every(function (entry) {
      return linkCode && String(entry.code || '').trim().toUpperCase() === linkCode;
    });
  }

  /* Amount taken off the cart by all discounts (codes and automatic). */
  function getCartDiscountTotal(cart) {
    const lineDiscountTotal = (cart.items || []).reduce(function (sum, item) {
      return sum + Math.max(0, Number(item.original_line_price || item.line_price || 0) - Number(item.final_line_price || item.line_price || 0));
    }, 0);
    return Math.max(Number(cart.total_discount || 0), lineDiscountTotal);
  }

  function showPromoFeedback(message, type) {
    if (!promoFeedback) return;
    promoFeedback.textContent = message || '';
    promoFeedback.hidden = !message;
    promoFeedback.classList.toggle('is-error', type === 'error');
    promoFeedback.classList.toggle('is-success', type === 'success');
  }

  function getAppliedPromo(cart, requestedCode) {
    const requested = (requestedCode || '').trim().toUpperCase();
    const discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    const applicableCode = discountCodes.find(function (entry) {
      return entry && entry.applicable !== false && (!requested || String(entry.code || '').toUpperCase() === requested);
    });
    return applicableCode ? String(applicableCode.code || requested).toUpperCase() : '';
  }

  /*
   * Shopify's cart only reports that a code did not apply, never why, so
   * the message is generic unless the code is one of the offers listed in
   * the promo panel (promo_offer metaobject) — then its dates, minimum
   * order value and eligibility text give a specific reason.
   */
  function findListedOffer(code) {
    return Array.from(drawer.querySelectorAll('.de-cart-promo__offer[data-promo-code]')).find(function (offer) {
      return String(offer.dataset.promoCode || '').trim().toUpperCase() === code;
    });
  }

  function describePromoRejection(cart, code) {
    const offer = findListedOffer(code);
    if (offer) {
      const now = Date.now() / 1000;
      const startsAt = Number(offer.dataset.deOfferStarts || 0);
      const endsAt = Number(offer.dataset.deOfferEnds || 0);
      if (endsAt && now > endsAt) return code + ' has expired.';
      if (startsAt && now < startsAt) return code + ' is not active yet.';

      const minOrderCents = Math.round(Number(offer.dataset.minOrder || 0) * 100);
      const subtotalCents = Number(cart.items_subtotal_price || 0);
      if (minOrderCents && subtotalCents < minOrderCents) {
        return 'Add ' + formatMoney(minOrderCents - subtotalCents) + ' more to use ' + code + '.';
      }

      const eligibility = offer.querySelector('.de-cart-promo__eligibility');
      if (eligibility && eligibility.textContent.trim()) {
        return code + " can't be applied to this order. " + eligibility.textContent.trim();
      }
    }
    return code + " can't be applied to this order. Please check the code and its terms.";
  }

  function setPromoUi(code) {
    const normalizedCode = (code || '').trim().toUpperCase();
    if (promoLabel) {
      /* Figma: "GHEECOMBO applied", code in ink and "applied" in green. */
      promoLabel.textContent = normalizedCode || 'Apply Promo Code';
      promoLabel.classList.toggle('is-applied', Boolean(normalizedCode));
      if (normalizedCode) {
        const appliedWord = document.createElement('span');
        appliedWord.className = 'de-cart-drawer__promo-applied-word';
        appliedWord.textContent = ' applied';
        promoLabel.appendChild(appliedWord);
      }
    }
    if (promoRemove) promoRemove.hidden = !normalizedCode;
    const appliedChip = drawer.querySelector('[data-de-promo-applied]');
    if (appliedChip) {
      appliedChip.hidden = !normalizedCode;
      const appliedChipCode = appliedChip.querySelector('[data-de-promo-applied-code]');
      if (appliedChipCode) appliedChipCode.textContent = normalizedCode;
    }
    if (checkoutLink) checkoutLink.href = '/checkout';
    drawer.dataset.promoCode = normalizedCode;
    drawer.querySelectorAll('[data-promo-code]').forEach(function (offer) {
      const selected = String(offer.dataset.promoCode || '').toUpperCase() === normalizedCode;
      offer.classList.toggle('is-selected', selected);
      const button = offer.querySelector('[data-de-promo-apply]');
      if (button && !button.disabled) button.textContent = selected ? 'APPLIED' : 'APPLY';
    });
  }

  async function updateShopifyDiscount(code) {
    return serializeCartMutation(async function () {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code || '' })
      });
      if (!response.ok) throw new Error('Shopify could not update this promo code.');
      return response.json();
    });
  }

  /* If removing an eligible product makes a discount code invalid, Shopify
     can leave a fully discounted gift line in the response. Clear the now
     invalid code and remove only zero-priced lines allocated to that code
     in the same cart update, so the gift cannot silently become chargeable. */
  async function cleanInvalidPromoGifts(cart) {
    const invalidCodes = (cart.discount_codes || []).filter(function (entry) {
      return entry && entry.applicable === false && entry.code;
    }).map(function (entry) {
      return String(entry.code).trim().toUpperCase();
    });
    if (!invalidCodes.length) return cart;

    const updates = {};
    (cart.items || []).forEach(function (item) {
      const isFreeLine = Number(item.final_line_price || 0) === 0 && Number(item.original_line_price || 0) > 0;
      const attributedToInvalidCode = (item.line_level_discount_allocations || []).some(function (allocation) {
        const application = allocation.discount_application || {};
        return application.type === 'discount_code' && invalidCodes.indexOf(String(application.title || '').trim().toUpperCase()) !== -1;
      });
      if (isFreeLine && attributedToInvalidCode) updates[item.variant_id] = 0;
    });

    const cleanedCart = await serializeCartMutation(async function () {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '', updates: updates })
      });
      if (!response.ok) throw new Error('Shopify could not clear the invalid promotion.');
      return response.json();
    });

    if (promoInput) promoInput.value = '';
    setPromoUi('');
    return cleanedCart;
  }

  function clearCustomerBrowserState() {
    ['deSfAuthenticated', 'deSfPhone', 'deAccountProfile', 'deAccountAddresses', 'deCheckoutDetails'].forEach(function (key) {
      localStorage.removeItem(key);
    });
  }

  window.dePrepareCustomerLogout = async function () {
    /* Clear account-identity state only. The cart itself is intentionally
       left intact: Shopify's cart cookie already persists it for this
       browser across sessions, guest or logged-in, and wiping it on
       logout would defeat that persistence. */
    clearCustomerBrowserState();
    document.cookie = PROMO_SESSION_COOKIE + '=; path=/; max-age=0; SameSite=Lax';

    try {
      await updateShopifyDiscount('');
    } catch (error) {
      console.warn('Unable to clear the promo code during logout.', error);
    }

    try {
      const cart = await getCart();
      renderCart(cart);
      updateHeaderCart(cart);
      return true;
    } catch (error) {
      console.error('Unable to refresh the cart during logout.', error);
      return false;
    }
  };

  async function applyPromoCode(code, sourceButton) {
    const normalizedCode = (code || '').trim().toUpperCase();
    if (!normalizedCode || promoBusy) return false;
    const previousCode = String(drawer.dataset.promoCode || '').trim().toUpperCase();
    if (previousCode === normalizedCode) {
      showPromoFeedback(normalizedCode + ' is already applied.', 'success');
      return true;
    }
    promoBusy = true;
    showPromoFeedback('Checking promo code…');
    if (promoSubmit) { promoSubmit.disabled = true; promoSubmit.classList.add('is-loading'); promoSubmit.textContent = 'WAIT'; }
    if (sourceButton) { sourceButton.classList.add('is-loading'); sourceButton.textContent = 'CHECKING'; }
    try {
      const cart = await updateShopifyDiscount(normalizedCode);
      const appliedCode = getAppliedPromo(cart, normalizedCode);
      if (!appliedCode) {
        const restoredCart = previousCode ? await updateShopifyDiscount(previousCode) : cart;
        setPromoUi(getAppliedPromo(restoredCart, previousCode));
        renderCart(restoredCart);
        showPromoFeedback(describePromoRejection(cart, normalizedCode), 'error');
        return false;
      }
      setPromoUi(appliedCode);
      if (promoInput) promoInput.value = appliedCode;
      renderCart(cart);
      const promoSavings = getCartDiscountTotal(cart);
      showPromoFeedback(appliedCode + ' applied.' + (promoSavings > 0 ? ' You saved ' + formatMoney(promoSavings) + '.' : ''), 'success');
      return true;
    } catch (error) {
      showPromoFeedback(error.message || 'Unable to apply this promo code. Please try again.', 'error');
      return false;
    } finally {
      promoBusy = false;
      if (promoSubmit) { promoSubmit.disabled = !(promoInput && promoInput.value.trim()); promoSubmit.classList.remove('is-loading'); promoSubmit.textContent = 'APPLY'; }
      if (sourceButton) sourceButton.classList.remove('is-loading');
    }
  }

  async function removePromoCode() {
    if (promoBusy) return;
    promoBusy = true;
    if (promoRemove) promoRemove.textContent = 'Removing…';
    try {
      const cart = await updateShopifyDiscount('');
      setPromoUi('');
      if (promoInput) promoInput.value = '';
      renderCart(cart);
      showPromoFeedback('Promo code removed.', 'success');
    } catch (error) {
      showPromoFeedback('Unable to remove the promo code. Please try again.', 'error');
    } finally {
      promoBusy = false;
      if (promoRemove) promoRemove.textContent = 'Remove Promocode';
      if (promoSubmit) promoSubmit.disabled = true;
    }
  }

  drawer.addEventListener('click', function (event) {
    const browseProducts = event.target.closest('.de-cart-empty__browse');
    if (browseProducts) {
      event.preventDefault();
      closeDrawer();

      const productsAnchor = document.getElementById('shop-products');
      if (productsAnchor) {
        window.history.replaceState(null, '', '/#shop-products');
        window.requestAnimationFrame(function () {
          productsAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      } else {
        window.location.assign('/#shop-products');
      }
      return;
    }

    if (event.target.closest('[data-de-promo-open]') && event.target !== promoRemove) {
      promoPanel.classList.add('is-open');
      promoPanel.setAttribute('aria-hidden', 'false');
    }

    if (event.target.closest('[data-de-promo-back], [data-de-promo-close]')) {
      promoPanel.classList.remove('is-open');
      promoPanel.setAttribute('aria-hidden', 'true');
    }

    const offerButton = event.target.closest('[data-de-promo-apply]');
    if (offerButton && !offerButton.disabled) {
      const offer = offerButton.closest('[data-promo-code]');
      applyPromoCode(offer.dataset.promoCode, offerButton).then(function (applied) {
        if (applied) {
          promoPanel.classList.remove('is-open');
          promoPanel.setAttribute('aria-hidden', 'true');
        }
      });
    }

    if (event.target === promoRemove || event.target.closest('[data-de-promo-chip-remove]')) {
      event.stopPropagation();
      removePromoCode();
    }
  });

  if (promoForm) {
    promoSubmit.disabled = true;
    promoInput.addEventListener('input', function () {
      promoSubmit.disabled = !promoInput.value.trim() || promoBusy;
      showPromoFeedback('');
    });
    promoForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!promoInput.value.trim()) return;
      applyPromoCode(promoInput.value).then(function (applied) {
        if (applied) {
          promoPanel.classList.remove('is-open');
          promoPanel.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  /* /cart redirects to /?cart=open (layout/theme.liquid). Read the flag now
     and drop the param so a refresh doesn't reopen it; the drawer is opened
     at the end of the pageshow reset below, which also fires on first load
     and would otherwise close it again. */
  const pageParams = new URLSearchParams(window.location.search);
  let openCartOnLoad = pageParams.get('cart') === 'open';
  /* Back from sign-in started at Checkout (/?checkout=start): continue the
     checkout straight away (checkout form, or Shopify checkout). */
  let resumeCheckoutOnLoad = pageParams.get('checkout') === 'start';
  /* Also resume when Shopify's sign-in ignores return_to and lands the
     shopper elsewhere: a flag set just before sending them to sign in. */
  try {
    if (drawer.dataset.customerId && sessionStorage.getItem('deResumeCheckout') === '1') resumeCheckoutOnLoad = true;
    if (drawer.dataset.customerId) sessionStorage.removeItem('deResumeCheckout');
  } catch (e) {}

  if (openCartOnLoad || resumeCheckoutOnLoad) {
    pageParams.delete('cart');
    pageParams.delete('checkout');
    const query = pageParams.toString();
    window.history.replaceState(
      null,
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );
  }

  window.addEventListener('pageshow', function () {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    promoPanel.classList.remove('is-open');
    promoPanel.setAttribute('aria-hidden', 'true');
    showPromoFeedback('');
    if (promoInput) promoInput.value = '';
    if (promoSubmit) {
      promoSubmit.disabled = true;
      promoSubmit.classList.remove('is-loading');
      promoSubmit.textContent = 'APPLY';
    }
    document.body.classList.remove('de-cart-open');
    getCart().then(function (cart) {
      const resetPromo = promoSessionEnded && !promoSessionChecked;
      promoSessionChecked = true;
      if (resetPromo && cartHasStalePromo(cart)) return updateShopifyDiscount('');
      return cart;
    }).then(function (cart) {
      renderCart(cart);
      if (resumeCheckoutOnLoad) {
        resumeCheckoutOnLoad = false;
        if (cart.items.length && drawer.dataset.customerId) {
          startCheckout();
          return;
        }
        openCartOnLoad = true;
      }
      if (openCartOnLoad) {
        openCartOnLoad = false;
        openDrawer(cart);
      }
    }).catch(function () {});
  });


  /* ==========================================================
     MONEY
     ========================================================== */

  function formatMoney(cents) {

    return '₹' + (
      Number(cents) / 100
    ).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });

  }


  /* ==========================================================
     ESCAPE HTML
     ========================================================== */

  function escapeHtml(value) {

    const div =
      document.createElement('div');

    div.textContent =
      value || '';

    return div.innerHTML;

  }


  /* ==========================================================
     UPDATE HEADER CART TOTAL
     ========================================================== */

  function syncProductPurchaseControls(cart) {

    const controls =
      document.querySelectorAll(
        '.de-purchase-control'
      );

    controls.forEach(function (control) {

      const variantId =
        Number(control.dataset.variantId);

      const item =
        cart.items.find(function (cartItem) {
          return cartItem.variant_id === variantId;
        });

      const quantity = item ? item.quantity : 0;
      const addButton = control.querySelector('.de-add-button');
      const quantityControl = control.querySelector('.de-quantity-control');
      const quantityValue = control.querySelector('.de-quantity-value');

      control.dataset.lineKey = item ? item.key : '';

      if (addButton) addButton.hidden = quantity > 0;
      if (quantityControl) quantityControl.hidden = quantity === 0;
      if (quantityValue) quantityValue.textContent = quantity;

    });

  }

  /* Popup (daily-categories) calls this after switching variant. */
  window.deSyncPurchaseControls = function () {
    if (lastCart) syncProductPurchaseControls(lastCart);
  };

  function updateHeaderCart(cart) {
    lastCart = cart;

    const total =
      document.getElementById(
        'de-header-cart-total'
      );

    const count =
      document.getElementById(
        'de-header-cart-count'
      );


    if (total) {

      total.textContent =
        formatMoney(
          cart.total_price
        );

    }


    if (count) {

      count.textContent =
        cart.item_count;

      count.hidden =
        cart.item_count === 0;

    }

    syncProductPurchaseControls(cart);


    /*
     * Tell any other Shopify section
     * that cart has changed.
     */

    document.dispatchEvent(
      new CustomEvent(
        'de:cart:updated',
        {
          detail: {
            cart: cart
          }
        }
      )
    );

  }


  /* ==========================================================
     LOAD CART
     ========================================================== */

  async function getCart() {
    if (cartRequestPromise) return cartRequestPromise;

    cartRequestPromise = (async function () {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) throw new Error('Unable to load cart');

      noteServerTime(response);
      return response.json();
    })();

    try {
      return await cartRequestPromise;
    } finally {
      cartRequestPromise = null;
    }

  }


  /* ==========================================================
     DELIVERY CUTOFF (India time)
     Ordered before 10 PM -> delivered tomorrow (D+1).
     Ordered at/after 10 PM -> delivered the day after (D+2).
     Uses Shopify's clock (the Date header on cart responses), not the
     shopper's device clock, so a wrong phone clock can't change the date.
     ========================================================== */

  const DELIVERY_CUTOFF_HOUR = 22;
  const IST_OFFSET_MS = 330 * 60 * 1000; /* India: UTC+5:30, no DST */
  let serverClockOffset = 0; /* Shopify time minus device time, in ms */

  function noteServerTime(response) {
    const header = response && response.headers ? response.headers.get('Date') : '';
    const serverTime = header ? Date.parse(header) : NaN;
    if (!isNaN(serverTime)) serverClockOffset = serverTime - Date.now();
  }

  function getDeliveryInfo() {
    /* Shift to India time and read it with the UTC getters. */
    const ist = new Date(Date.now() + serverClockOffset + IST_OFFSET_MS);
    const beforeCutoff = ist.getUTCHours() < DELIVERY_CUTOFF_HOUR;
    const daysAhead = beforeCutoff ? 1 : 2;
    const delivery = new Date(Date.UTC(ist.getUTCFullYear(), ist.getUTCMonth(), ist.getUTCDate() + daysAhead));
    return {
      beforeCutoff: beforeCutoff,
      daysAhead: daysAhead,
      shortLabel: delivery.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short', timeZone: 'UTC' }),
      fullLabel: delivery.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' })
    };
  }

  function updateDeliveryMessage() {
    if (!deliveryMessage) return;
    const delivery = getDeliveryInfo();
    deliveryMessage.textContent = delivery.beforeCutoff
      ? 'Order before 10 PM for delivery tomorrow • ' + delivery.shortLabel
      : '10 PM cut-off passed • Delivery on ' + delivery.shortLabel;
  }

  /* Keep the message right if the drawer stays open across 10 PM. */
  window.setInterval(updateDeliveryMessage, 60000);

  /*
   * Checkout:
   *  - guests are sent to sign in, then back to the cart;
   *  - every signed-in customer fills the checkout form
   *    (snippets/de-checkout-form, pre-filled from their current default
   *    address when they have one), which saves it as their default so the
   *    community picker's validation and search (DE-013/DE-014) are always
   *    enforced instead of being skippable on repeat checkouts;
   *  - then the delivery date is saved on the order as cart attributes
   *    (Admin "Additional details", emails, My Account, invoice) and the
   *    shopper continues to Shopify checkout, which pre-fills the default
   *    address.
   */
  if (checkoutLink) {
    checkoutLink.addEventListener('click', function (event) {
      event.preventDefault();
      startCheckout();
    });
  }

  function startCheckout() {
    if (!checkoutLink || checkoutLink.dataset.busy === 'true') return;
    if (!drawer.dataset.customerId) {
      try { sessionStorage.setItem('deResumeCheckout', '1'); } catch (e) {}
      window.location.assign(drawer.dataset.loginUrl || '/account/login');
      return;
    }
    if (window.deOpenCheckoutForm) {
      window.deOpenCheckoutForm(continueToCheckout);
      return;
    }
    continueToCheckout();
  }

  async function continueToCheckout() {
    if (checkoutLink.dataset.busy === 'true') return;
    checkoutLink.dataset.busy = 'true';
    const delivery = getDeliveryInfo();
      try {
        const response = await serializeCartMutation(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'Delivery Date': delivery.fullLabel,
                'Delivery Cutoff': delivery.beforeCutoff ? 'Ordered before 10 PM (D+1)' : 'Ordered after 10 PM (D+2)'
              }
            })
          });
        });
        noteServerTime(response);
      } catch (error) {
        console.warn('Could not save the delivery date on the cart.', error);
      }
      window.location.assign(checkoutLink.getAttribute('href') || '/checkout');
  }


  /* ==========================================================
     RENDER CART
     ========================================================== */

  /*
   * Every discount Shopify applied to this cart with the amount it took
   * off: automatic discounts (their title) and discount codes (the code).
   * Order-level ones sit on the cart, product-level ones on each line.
   */
  function getDiscountBreakdown(cart) {
    const breakdown = [];
    function add(title, amount) {
      title = String(title || '').trim();
      amount = Number(amount || 0);
      if (!title || amount <= 0) return;
      const existing = breakdown.find(function (entry) { return entry.title === title; });
      if (existing) existing.amount += amount;
      else breakdown.push({ title: title, amount: amount });
    }
    (cart.cart_level_discount_applications || []).forEach(function (application) {
      add(application.title, application.total_allocated_amount);
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        add(allocation.discount_application && allocation.discount_application.title, allocation.amount);
      });
    });
    return breakdown;
  }

  function renderCart(cart) {
    lastCart = cart;

    updateHeaderCart(cart);
    drawer.classList.toggle('is-empty', !cart.items.length);


    if (itemCountElement) {

      itemCountElement.textContent =
        cart.item_count;

    }


    if (subtotalElement) {

      subtotalElement.textContent =
        formatMoney(
          cart.total_price
        );

    }


    const summarySubtotal = document.getElementById('de-cart-summary-subtotal');
    const summaryTotal = document.getElementById('de-cart-summary-total');
    const summaryItems = document.getElementById('de-cart-summary-items');
    const summaryDiscounts = document.getElementById('de-cart-summary-discounts');
    const summaryTax = document.getElementById('de-cart-summary-tax');
    const summaryTaxLabel = document.getElementById('de-cart-tax-label');
    const summaryTaxRow = summaryTax && summaryTax.closest('.de-cart-drawer__tax');
    const originalTotal = Number(cart.original_total_price != null ? cart.original_total_price : cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    const discountTotal = getCartDiscountTotal(cart);
    const finalTotal = Number(cart.total_price || 0);
    const totalTax = Number(cart.total_tax || 0);

    if (summarySubtotal) summarySubtotal.textContent = formatMoney(originalTotal);

    /* One summary row per discount, e.g. "Offer Applied (TEST10)  -₹45"
       and "Offer Applied (Ghee Week)  -₹20" (Figma wording), so each
       saving is listed separately. */
    const appliedPromoCode = getAppliedPromo(cart);
    const discountBreakdown = getDiscountBreakdown(cart);
    if (summaryDiscounts) {
      const rows = discountBreakdown.length
        ? discountBreakdown
        : (discountTotal > 0 ? [{ title: '', amount: discountTotal }] : []);
      summaryDiscounts.innerHTML = rows.map(function (entry) {
        const label = !entry.title
          ? 'Discount'
          : 'Offer Applied (' + entry.title + ')';
        return `<div class="de-cart-drawer__summary-row de-cart-drawer__discount"><span>${escapeHtml(label)}</span><span>-${formatMoney(entry.amount)}</span></div>`;
      }).join('');
    }

    const savingsBanner = document.getElementById('de-cart-savings');
    const savingsAmount = document.getElementById('de-cart-savings-amount');
    const savingsTitles = document.getElementById('de-cart-savings-titles');
    if (savingsBanner) {
      /* Automatic discounts only (applied without a code), styled like an
         applied promo code: "Test10DAL applied" / "You saved ₹29". A promo
         code already shows on the Apply Promo Code button and in Order
         Summary, so it isn't repeated here. */
      const automaticDiscounts = discountBreakdown.filter(function (entry) {
        return entry.title.toUpperCase() !== appliedPromoCode;
      });
      const automaticTotal = automaticDiscounts.reduce(function (sum, entry) { return sum + entry.amount; }, 0);
      savingsBanner.hidden = automaticTotal <= 0;
      if (savingsAmount) {
        /* Same wording as an applied promo code: "Test10DAL applied". */
        savingsAmount.textContent = automaticDiscounts.map(function (entry) { return entry.title; }).join(', ');
        const appliedWord = document.createElement('span');
        appliedWord.className = 'de-cart-drawer__savings-applied-word';
        appliedWord.textContent = ' applied';
        savingsAmount.appendChild(appliedWord);
      }
      if (savingsTitles) {
        savingsTitles.textContent = 'You saved ' + formatMoney(automaticTotal);
      }
    }
    /* Shopify only resolves total_tax once it can determine a tax
       jurisdiction; until then it reports 0 and the row stays hidden
       rather than show a misleading ₹0. */
    if (summaryTaxRow) summaryTaxRow.hidden = totalTax <= 0;
    if (totalTax > 0) {
      if (summaryTaxLabel) summaryTaxLabel.textContent = cart.taxes_included ? 'Tax (included)' : 'Tax';
      if (summaryTax) summaryTax.textContent = formatMoney(totalTax);
    }
    if (summaryTotal) summaryTotal.textContent = formatMoney(finalTotal);
    if (subtotalElement) subtotalElement.textContent = formatMoney(finalTotal);
    setPromoUi(getAppliedPromo(cart));
    if (summaryItems) {
      summaryItems.innerHTML = cart.items.map(function (item) {
        return `<div class="de-cart-summary-item"><span>${escapeHtml(item.product_title)} | x${item.quantity}</span><span>${formatMoney(item.final_line_price)}</span></div>`;
      }).join('');
    }

    if (!cart.items.length) {

      itemsContainer.innerHTML = `
        <div class="de-cart-drawer__empty">
          <img class="de-cart-empty__visual" src="${window.deCartAssets.emptyCart}" alt="" aria-hidden="true">
          <h3>Your cart is empty!</h3>
          <p>Looks like you haven’t added anything yet!</p>
          <a class="de-cart-empty__browse" href="/#shop-products">Browse Products</a>
        </div>
      `;

      return;

    }


    itemsContainer.innerHTML =
      cart.items.map(
        function (item) {

          /* 72px thumbnail: ask Shopify's CDN for a 144px (2x) copy instead
             of the original upload, which can be several hundred KB. */
          const image =
            item.image
              ? item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=144'
              : '';


          const title =
            escapeHtml(
              item.product_title
            );

          /* Struck-through price: the compare-at ("was") price when the
             product has one, otherwise the pre-discount price. */
          const compareAtUnit = Number((window.deCompareAtPrices || {})[item.variant_id] || 0);
          const strikePrice = Math.max(Number(item.original_line_price) || 0, compareAtUnit * item.quantity);


          return `

            <div
              class="de-cart-drawer__item"
              data-line="${item.key}"
            >

              <img
                src="${image}"
                width="72"
                height="72"
                class="de-cart-drawer__item-image"
                alt="${title}"
                loading="lazy"
              >


              <div class="de-cart-drawer__item-content">

                <p class="de-cart-drawer__item-title">
                  ${title}
                </p>

                <div class="de-cart-drawer__item-variant">
                  ${escapeHtml(item.variant_title === 'Default Title' ? '' : item.variant_title)}
                </div>


                <div class="de-cart-drawer__item-price">
                  ${formatMoney(item.final_line_price)}
                  ${strikePrice > Number(item.final_line_price) ? `<span class="de-cart-drawer__item-original-price">${formatMoney(strikePrice)}</span>` : ''}
                  ${item.quantity > 1 ? `<span class="de-cart-drawer__item-unit-price">${formatMoney(item.final_price)} each</span>` : ''}
                </div>

                <button type="button" class="de-cart-remove de-cart-quantity-button" data-action="remove" data-line="${item.key}" aria-label="Remove ${title}">
                  <img src="${window.deCartAssets.remove}" alt="" width="20" height="20" loading="lazy">
                </button>


                <div class="de-cart-drawer__quantity">

                  <button
                    type="button"
                    class="de-cart-quantity-button"
                    data-action="decrease"
                    data-line="${item.key}"
                    aria-label="Decrease quantity"
                  >
                    <img src="${window.deCartAssets.minus}" alt="" width="12" height="12" loading="lazy">
                  </button>


                  <span class="de-cart-quantity-value">
                    ${item.quantity}
                  </span>


                  <button
                    type="button"
                    class="de-cart-quantity-button"
                    data-action="increase"
                    data-line="${item.key}"
                    aria-label="Increase quantity"
                  >
                    <img src="${window.deCartAssets.plus}" alt="" width="12" height="12" loading="lazy">
                  </button>

                </div>

              </div>

              ${cartItemErrors[item.variant_id] ? `<p class="de-cart-drawer__item-error" role="alert">${escapeHtml(cartItemErrors[item.variant_id])}</p>` : ''}

            </div>

          `;

        }
      ).join('');


    bindQuantityButtons();

  }


  /* ==========================================================
     OPEN DRAWER
     ========================================================== */

  /* Pass a cart that was just fetched (e.g. after add-to-cart) to skip
     a duplicate /cart.js round trip. */
  function openDrawer(preloadedCart) {

    updateDeliveryMessage();

    drawer.classList.add('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.style.overflow =
      'hidden';


    /*
     * Load cart AFTER drawer opens.
     *
     * This is important for speed.
     */

    const cartToRender = preloadedCart
      ? Promise.resolve(preloadedCart)
      : cartRequestPromise || (lastCart ? Promise.resolve(lastCart) : getCart());

    cartToRender
      .then(function (cart) {
        updateHeaderCart(cart);
        renderCart(cart);
        return null;

      })
      .catch(function (error) {

        console.error(
          'Cart loading error:',
          error
        );

      });

  }


  /* ==========================================================
     CLOSE DRAWER
     ========================================================== */

  function closeDrawer() {

    drawer.classList.remove(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.style.overflow =
      '';

    /*
     * Once the shopper has dismissed the drawer, stop auto-opening it
     * on every add-to-cart for the rest of this session — let them add
     * as many products as they want and open the basket themselves
     * when they're ready.
     */
    try {
      sessionStorage.setItem('deCartDrawerDismissed', 'true');
    } catch (error) {
      /* Storage unavailable (private browsing, etc.) — safe to ignore. */
    }

  }

  function hasDismissedDrawer() {
    try {
      return sessionStorage.getItem('deCartDrawerDismissed') === 'true';
    } catch (error) {
      return false;
    }
  }

  /* ==========================================================
     ADDED-TO-CART TOAST
     Shown instead of the drawer once the shopper has dismissed
     it once this session — a quick top-right confirmation that
     doesn't interrupt browsing.
     ========================================================== */

  let toastTimer = null;
  let toastHideTimer = null;

  /* Shopify cart errors come back as JSON {status, message, description};
     the description is the shopper-facing text ("... is already sold out."). */
  async function readCartError(response, fallback) {
    try {
      const data = await response.json();
      return data.description || data.message || fallback;
    } catch (error) {
      return fallback;
    }
  }

  let errorToastTimer = null;

  function showCartError(message) {
    const toast = document.getElementById('de-cart-error-toast');
    const text = document.getElementById('de-cart-error-text');
    if (!toast || !text) return;
    /* Last child of <body> so it is always above the page and the drawer. */
    if (toast.parentNode !== document.body || toast.nextElementSibling) document.body.appendChild(toast);
    text.textContent = message;
    toast.hidden = false;
    clearTimeout(errorToastTimer);
    errorToastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
  }

  /* Errors for a product that is in the open cart are shown inside that
     cart item (red box under it); anything else uses the top toast. */
  const cartItemErrors = {};
  let cartItemErrorTimer = null;

  function reportCartError(message, variantId) {
    if (variantId && drawer.classList.contains('is-open')) {
      cartItemErrors[Number(variantId)] = message;
      clearTimeout(cartItemErrorTimer);
      cartItemErrorTimer = setTimeout(function () {
        Object.keys(cartItemErrors).forEach(function (key) { delete cartItemErrors[key]; });
        if (lastCart) renderCart(lastCart);
      }, 6000);
      return;
    }
    showCartError(message);
  }

  /* /cart/change.js and /cart/add.js silently clamp the quantity to what's
     actually available instead of erroring when stock runs out between
     page load and this request (or a variant with no inventory tracking
     still gets capped by Shopify) -- a plain response.ok check misses
     that. Call this after any successful quantity increase to tell the
     shopper when fewer than requested were actually added. */
  function reportAvailabilityLimit(requested, actual, variantId) {
    if (actual >= requested) return;
    const message = actual > 0
      ? 'Only ' + actual + ' item' + (actual === 1 ? ' was' : 's were') + ' added to your cart due to availability.'
      : 'This product is no longer available.';
    reportCartError(message, variantId);
  }

  function showAddedToCartToast() {
    const toast = document.getElementById('de-cart-toast');
    if (!toast) return;

    clearTimeout(toastTimer);
    clearTimeout(toastHideTimer);

    toast.hidden = false;
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      toastHideTimer = setTimeout(function () {
        toast.hidden = true;
      }, 250);
    }, 2200);
  }


  if (closeButton) {

    closeButton.addEventListener(
      'click',
      closeDrawer
    );

  }


  if (overlay) {

    overlay.addEventListener(
      'click',
      closeDrawer
    );

  }


  /* ==========================================================
     QUANTITY
     ========================================================== */

  function bindQuantityButtons() {

    const buttons =
      itemsContainer.querySelectorAll(
        '.de-cart-quantity-button'
      );


    buttons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          async function () {

            if (
              button.disabled
            ) {
              return;
            }


            button.disabled =
              true;


            const line =
              button.dataset.line;


            const action =
              button.dataset.action;


            try {

              /*
               * Use the cart from the last render; only fetch when it
               * is missing or no longer contains this line.
               */

              let cart =
                lastCart && lastCart.items.some(function (cartItem) { return cartItem.key === line; })
                  ? lastCart
                  : await getCart();


              let item =
                cart.items.find(
                  function (cartItem) {

                    return (
                      cartItem.key ===
                      line
                    );

                  }
                );


              if (!item) {

                renderCart(cart);

                return;

              }



              let quantity =
                item.quantity;


              if (
                action ===
                'increase'
              ) {

                quantity++;

              }


              if (
                action ===
                'decrease'
              ) {

                quantity--;

              }

              if (
                action ===
                'remove'
              ) {

                quantity = 0;

              }


              if (quantity < 0) {

                quantity = 0;

              }


              /*
               * Update Shopify
               */

              const response =
                await serializeCartMutation(function () { return fetch(
                  '/cart/change.js',
                  {
                    method: 'POST',

                    headers: {
                      'Content-Type':
                        'application/json',

                      'Accept':
                        'application/json'
                    },

                    body:
                      JSON.stringify({
                        id: item.key,
                        quantity: quantity
                      })
                  }
                ); });


              if (!response.ok) {

                reportCartError(await readCartError(response, 'Your cart could not be updated.'), item.variant_id);
                renderCart(await getCart());
                return;

              }


              let updatedCart = await response.json();
              if (action === 'remove' || quantity === 0) {
                updatedCart = await cleanInvalidPromoGifts(updatedCart);
              }

              if (action === 'increase') {
                /* Match by variant_id, not key: Shopify can regenerate a
                   line's key (e.g. recalculating discount allocations),
                   so the pre-request key may no longer be present even
                   though the line itself is still there. */
                const updatedItem = updatedCart.items.find(function (cartItem) { return cartItem.variant_id === item.variant_id; });
                reportAvailabilityLimit(quantity, updatedItem ? updatedItem.quantity : 0, item.variant_id);
              }

              renderCart(
                updatedCart
              );


            } catch (error) {

              console.error(
                'Quantity update error:',
                error
              );
              showCartError('Your cart could not be updated. Please try again.');

            } finally {

              button.disabled =
                false;

            }

          }
        );

      }
    );

  }


  /* ==========================================================
     ADD TO CART
     ========================================================== */

  async function handleAddToCart(
    button
  ) {

    if (
      button.dataset.adding ===
      'true'
    ) {
      return;
    }


    const variantId =
      button.dataset.variantId;


    if (!variantId) {

      console.error(
        'Missing variant ID'
      );

      return;

    }


    button.dataset.adding =
      'true';

    button.disabled =
      true;


    try {

      /*
       * Add product.
       */

      const response =
        await serializeCartMutation(function () { return fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify({

                items: [
                  {
                    id:
                      Number(
                        variantId
                      ),
                    quantity: 1
                  }
                ]

              })
          }
        ); });


      if (!response.ok) {

        const message = await readCartError(response, 'This product could not be added to your cart.');
        reportCartError(message, Number(variantId));
        /* Sold out since the page loaded: switch the button without a refresh. */
        if (/sold out/i.test(message)) {
          button.dataset.soldOut = 'true';
          button.textContent = 'Sold Out';
          button.classList.add('de-add-button--soldout');
        }
        getCart().then(function (freshCart) {
          updateHeaderCart(freshCart);
          if (drawer.classList.contains('is-open')) renderCart(freshCart);
        }).catch(function () {});
        return;

      }


      /*
       * Get updated cart ONCE.
       */

      let cart = await getCart();
      cart = await cleanInvalidPromoGifts(cart);


      /*
       * Update header immediately.
       */

      updateHeaderCart(
        cart
      );

      document.dispatchEvent(
        new CustomEvent('de:reset-product-search')
      );


      /*
       * Open drawer immediately — but only if the shopper hasn't
       * already dismissed it once this session. After a dismissal,
       * let them keep adding products without the drawer popping
       * open every time; they can open it themselves via the basket
       * icon (see the HEADER CART CLICK handler below, which always
       * opens regardless of this flag).
       */

      if (!hasDismissedDrawer()) {
        openDrawer(cart);
      } else {
        updateDeliveryMessage();
        showAddedToCartToast();
      }


    } catch (error) {

      console.error(
        'Add to cart error:',
        error
      );
      showCartError('This product could not be added. Please try again.');

    } finally {

      button.dataset.adding =
        'false';

      button.disabled =
        button.dataset.soldOut === 'true';

    }

  }


  /* ==========================================================
     ADD BUTTONS
     ========================================================== */

  function bindAddButtons() {

    const buttons =
      document.querySelectorAll(
        '.de-add-button'
      );


    buttons.forEach(
      function (button) {

        /*
         * Prevent duplicate binding.
         */

        if (
          button.dataset.deCartBound ===
          'true'
        ) {
          return;
        }


        button.dataset.deCartBound =
          'true';


        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            event.stopImmediatePropagation();

            handleAddToCart(
              button
            );

          }
        );

      }
    );

  }

  document.addEventListener(
    'click',
    async function (event) {

      const quantityButton =
        event.target.closest(
          '.de-quantity-button'
        );

      if (!quantityButton) return;

      event.preventDefault();

      const control =
        quantityButton.closest(
          '.de-purchase-control'
        );

      const variantId = Number(control.dataset.variantId);
      const quantityValue = control.querySelector('.de-quantity-value');
      const currentQuantity = Number(quantityValue.textContent) || 0;
      const nextQuantity = Math.max(0, currentQuantity + Number(quantityButton.dataset.delta));

      if (!variantId) return;

      quantityButton.disabled = true;

      try {
        /* /cart/change.js accepts the variant ID directly, so no /cart.js
           fetch is needed first. The applied promo code is kept. */
        const lineKey = String(variantId);

        const response = await serializeCartMutation(function () { return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: lineKey, quantity: nextQuantity })
        }); });

        if (!response.ok) {
          reportCartError(await readCartError(response, 'Your cart could not be updated.'), variantId);
          const freshCart = await getCart();
          updateHeaderCart(freshCart);
          if (drawer.classList.contains('is-open')) renderCart(freshCart);
          return;
        }

        let cart = await response.json();
        cart = await cleanInvalidPromoGifts(cart);
        updateHeaderCart(cart);

        if (Number(quantityButton.dataset.delta) > 0) {
          const updatedItem = cart.items.find(function (cartItem) { return cartItem.variant_id === variantId; });
          reportAvailabilityLimit(nextQuantity, updatedItem ? updatedItem.quantity : 0, variantId);
          if (drawer.classList.contains('is-open')) renderCart(cart);
        }

      } catch (error) {
        console.error('Quantity update error:', error);
        showCartError('Your cart could not be updated. Please try again.');
      } finally {
        quantityButton.disabled = false;
      }

    }

  );


  /* ==========================================================
     HEADER CART INITIAL LOAD
     ========================================================== */

  /* ==========================================================
     HEADER CART CLICK
     ========================================================== */

  function bindCartTriggers(scope) {
    const container = scope || document;
    container.querySelectorAll('[data-de-cart-open]').forEach(function (trigger) {
      if (trigger.dataset.deCartOpenBound === 'true') return;
      trigger.dataset.deCartOpenBound = 'true';
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer();
      });
    });
  }


  /* ==========================================================
     INITIALISE
     ========================================================== */

  bindAddButtons();
  bindCartTriggers();

  /* No initial initialiseHeaderCart() here: the pageshow handler above
     (which also fires on first load) already fetches and renders the
     cart, header included. Calling both doubled /cart.js on every page. */


  /*
   * Shopify theme editor support.
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      bindAddButtons();
      bindCartTriggers(event.target);

    }
  );


})();


/*
 * Offer schedule (promo_offer starts_at / ends_at). Liquid already hides
 * offers outside their window when the page renders, but storefront pages
 * are cached, so re-check against the shopper's clock on load and every
 * minute. Covers the offer cards in the cart promo panel.
 */
(function () {
  'use strict';

  function applyOfferSchedule() {
    const now = Date.now() / 1000;
    document.querySelectorAll('[data-de-offer-starts], [data-de-offer-ends]').forEach(function (element) {
      const startsAt = Number(element.dataset.deOfferStarts || 0);
      const endsAt = Number(element.dataset.deOfferEnds || 0);
      element.hidden = Boolean((startsAt && now < startsAt) || (endsAt && now > endsAt));
    });
  }

  applyOfferSchedule();
  window.setInterval(applyOfferSchedule, 60000);
  document.addEventListener('shopify:section:load', applyOfferSchedule);
})();
